import { render, staticRenderFns } from "./courseUnits.vue?vue&type=template&id=41330433"
import script from "./courseUnits.vue?vue&type=script&lang=js"
export * from "./courseUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports